<button
  class="action-btn {{ type }}-btn align-{{ align }}"
  [class.full-width]="fullWidth"
  [class.loading-effect]="isLoading"
  [class.abbreviated]="abbreviation"
  [attr.aria-label]="ariaLabel || null"
  [attr.data-testid]="testId || null"
  [disabled]="disabled"
>
  <ng-container *ngIf="(lucideIcon || icon) && iconPosition === 'start' && !isLoading">
    <span class="icon">
      <ui-icon *ngIf="lucideIcon; else legacyStartIcon" [name]="lucideIcon" [size]="lucideSize"></ui-icon>
      <ng-template #legacyStartIcon>
        <ui-svg-icon [svgIcon]="icon!" [rotated]="rotated" [size]="iconSize"></ui-svg-icon>
      </ng-template>
    </span>
  </ng-container>
  <ng-container *ngIf="isLoading">
    <span class="icon">
      <div class="spinner"></div>
    </span>
  </ng-container>
  <span *ngIf="label" class="label">{{ label }}</span>
  <span style="line-height: 140%" *ngIf="abbreviation" class="label-abbreviation">{{ abbreviation }}</span>
  <ng-container *ngIf="(lucideIcon || icon) && iconPosition === 'end'">
    <span class="icon">
      <ui-icon *ngIf="lucideIcon; else legacyEndIcon" [name]="lucideIcon" [size]="lucideSize"></ui-icon>
      <ng-template #legacyEndIcon>
        <ui-svg-icon [svgIcon]="icon!" [rotated]="rotated" [size]="iconSize"></ui-svg-icon>
      </ng-template>
    </span>
  </ng-container>
  <ng-container *ngIf="counter">
    <span class="counter">{{ counter }}</span>
  </ng-container>
</button>